






































































































































































































































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';

import TableWidthMixin from '@root/common/mixins/table-width';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import Utils from '@root/utils/common';
import { recordchchTypeMap, gudMethodsMap } from '../../../types/fixed-car-management/dictionaries';
import moment from 'moment';
import PlateInput from '../../../components/plate-input/index.vue';
import { queryMonthCardPaymentList, quertcancel, monthCardPaymentExcelExport } from '@/api/fixed-car-management';
import { Getter } from 'vuex-class';
import DistributionTrack from '@/components/distribution-track/index.vue';
@Component({
  name: 'TradeRecord',
  components: {
    ParkingLotSearch,
    PlateInput,
    DistributionTrack
  }
})
// @Component
export default class TradeRecord extends Mixins(TableMixin, TableWidthMixin) {
  // paymentChannels = Utils.toLabelVal(TraderecordChannelMap)
  payment_pay_channel: any;
  get paymentChannels() {
    return Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.payment_pay_channel);
  }
  @Getter('dictionaries/paymentCardType')
  paymentCardType?: any;
  get businessType() {
    return Utils.toLabelVal(this.paymentCardType);
  }

  @Getter('dictionaries/allDictionaries')
  allDictionaries?: any;
  get payType() {
    return Utils.toLabelVal(this.allDictionaries.payment_trade_type);
  }
  @Getter('dictionaries/newCardPaymentPayType')
  newCardPaymentPayType?: any;
  get payMethods() {
    return Utils.toLabelVal(this.newCardPaymentPayType);
  }
  // 记录状态
  recordchchOptions: IOption[] = Utils.toLabelVal(recordchchTypeMap);
  private filterParam: any = {
    parkId: [],
    spaceCode: '',
    paidTimeStart: moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00',
    paidTimeEnd: moment(new Date()).format('YYYY-MM-DD') + ' 23:59:59',
    plateHead: '',
    plateTail: '',
    payChannel: [],
    cardType: [],
    tradeType: [],
    payType: [],
    dealStatusList: [], //记录状态
    packageName: '', //套餐名称
    paidPriceOrderBy: '',
    paidTimeOrderBy: ''
  };
  clearPlate = false;
  allowClear: boolean = false;
  canExport: boolean = true;
  clear({ defaultParkIdList }) {
    this.clearPlate = true;
    this.filterParam = {
      parkId: defaultParkIdList,
      spaceCode: '',
      paidTimeStart: moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00',
      paidTimeEnd: moment(new Date()).format('YYYY-MM-DD') + ' 23:59:59',
      plateHead: '',
      plateTail: '',
      payChannel: [],
      cardType: [],
      tradeType: [],
      payType: [],
      dealStatusList: [], //记录状态
      packageName: '', //套餐名称
      paidPriceOrderBy: '',
      paidTimeOrderBy: ''
    };
    this.current = 1;
    this.fetchTableData();
  }
  tableData: any[] = []; // 表数据
  totalRow: any = {}; // 合计
  tableLoading: boolean = false;
  get defaultTime() {
    if (this.filterParam.paidTimeStart && this.filterParam.paidTimeEnd) {
      return [
        this.moment(this.filterParam.paidTimeStart, 'YYYY-MM-DD HH:mm:ss'),
        this.moment(this.filterParam.paidTimeEnd, 'YYYY-MM-DD HH:mm:ss')
      ];
    } else if (this.filterParam.paidTimeStart) {
      return [this.moment(this.filterParam.paidTimeStart, 'YYYY-MM-DD HH:mm:ss')];
    } else {
      return [];
    }
  }
  set defaultTime(val: any) {}
  async created() {
    this.fetchTableData();
  }

  /**
   * 点击搜索按钮
   */
  private search() {
    this.current = 1;
    this.fetchTableData();
  }
  private showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.fetchTableData();
  }
  /**
   * 获取列表数据
   */
  public async fetchTableData() {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const {
        parkId,
        spaceCode,
        paidTimeStart,
        paidTimeEnd,
        plateHead,
        plateTail,
        payChannel,
        cardType,
        tradeType,
        payType,
        dealStatusList,
        packageName,
        paidPriceOrderBy,
        paidTimeOrderBy
      } = this.filterParam;
      if (plateTail && plateHead === '') {
        return this.$message.error('请先选择省份再进行查询');
      }

      const { status, msg, code, data } = await queryMonthCardPaymentList({
        parkId: '' + parkId,
        spaceCode,
        paidTimeStart,
        paidTimeEnd,
        plateHead,
        plateTail,
        payChannel: '' + payChannel,
        cardType: '' + cardType,
        tradeType: '' + tradeType,
        payType: '' + payType,
        packageName,
        currPage: this.current,
        pageSize: this.pageSize,
        dealStatusList: dealStatusList.join(','),
        paidPriceOrderBy,
        paidTimeOrderBy
      });
      if (data) {
        const { pageSize = 0, currPage = 0, totalPage, totalNum = 0, datas = [], total } = data;
        this.total = Number(totalNum);
        if (datas.length > 0) {
          this.tableData = datas;
          this.totalRow = {
            ...total
          };
        } else {
          this.tableData = [];
        }
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('queryMonthCardPaymentList  接口调用错误', error);
    } finally {
      this.tableLoading = false;
    }
  }

  private moment = moment;

  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }

  private onTimeChange(date: any, dateString: any) {
    const [paidTimeStart, paidTimeEnd] = dateString;
    this.filterParam.paidTimeStart = paidTimeStart;
    this.filterParam.paidTimeEnd = paidTimeEnd;
  }

  plateChange([plateHead, plateTail]: any) {
    this.filterParam.plateHead = plateHead;
    this.filterParam.plateTail = plateTail;
  }

  // 删除确认
  async cancellationSub(row: any) {
    try {
      const res = await quertcancel({ id: row.id });
      this.$message.success(res.msg || '删除成功');
      this.fetchTableData();
    } catch (e) {
      this.$message.error(e.msg || '删除失败');
    }
  }
  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => {
          if (record.isTotal === true) {
            return '';
          }
          return `${(this.current - 1) * this.pageSize + index + 1}`;
        }
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'to-parking-space-detail' }
      },
      {
        title: '套餐名称',
        dataIndex: 'packageName',
        width: 120,
        scopedSlots: { customRender: 'to-package-detail' }
      },
      {
        title: '记录状态',
        width: 120,
        dataIndex: 'dealStatus'
        // scopedSlots: { customRender: 'dealStatus' },
      },
      {
        title: '车位号',
        width: 170,
        dataIndex: 'spaceCode',
        scopedSlots: { customRender: 'spaceCode' }
      },
      {
        title: '车位用途',
        width: 120,
        dataIndex: 'cardType'
      },
      {
        title: '车牌号',
        dataIndex: 'plate',
        width: 180,
        scopedSlots: { customRender: 'plate' }
      },
      {
        title: '客户姓名',
        dataIndex: 'userName',
        width: 170,
        scopedSlots: { customRender: 'userName' }
      },
      {
        title: '交易订单号',
        dataIndex: 'tradeNo',
        width: 240,
        scopedSlots: { customRender: 'tradeNo' }
      },
      {
        title: '授权期始',
        dataIndex: 'startDate',
        width: 200
      },
      {
        title: '授权期止',
        dataIndex: 'endDate',
        width: 200
      },
      {
        title: '操作类型',
        width: 120,
        dataIndex: 'tradeType'
      },
      {
        title: '交易金额',
        width: 120,
        dataIndex: 'paidPrice',
        sortable: true,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '缴费方式',
        width: 120,
        dataIndex: 'payType'
      },
      {
        title: '缴费来源',
        width: 120,
        dataIndex: 'payChannel'
      },
      {
        title: '操作人',
        width: 120,
        dataIndex: 'operater'
      },
      {
        title: '备注',
        dataIndex: 'des',
        width: 180,
        scopedSlots: { customRender: 'des' }
      },
      {
        title: '交易时间',
        dataIndex: 'paidTime',
        width: 240,
        sortable: true
      },
      {
        title: '下发状态',
        width: 120,
        dataIndex: 'sendResult',
        scopedSlots: { customRender: 'sendResult' }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 80,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }
  mounted() {}
  //导出
  private async downLoad() {
    try {
      this.canExport = false;
      const {
        parkId,
        spaceCode,
        paidTimeStart,
        paidTimeEnd,
        plateHead,
        plateTail,
        payChannel,
        cardType,
        tradeType,
        payType,
        dealStatusList,
        packageName,
        paidPriceOrderBy,
        paidTimeOrderBy
      } = this.filterParam;
      this.canExport = true;

      await monthCardPaymentExcelExport(
        {
          parkId: '' + parkId,
          spaceCode,
          paidTimeStart,
          paidTimeEnd,
          plateHead,
          plateTail,
          payChannel: '' + payChannel,
          cardType: '' + cardType,
          tradeType: '' + tradeType,
          payType: '' + payType,
          packageName,
          dealStatusList: dealStatusList.join(','),
          paidPriceOrderBy,
          paidTimeOrderBy
        },
        '固定车辆交易记录'
      );
    } catch (e) {
      this.canExport = true;
      console.log('couponExport', '导出失败');
    }
  }

  // 表头筛选
  onSortChange({ sortList = [], property, order }) {
    // fetchTableData 查询方法
    sortList.forEach(item => {
      this.filterParam[`${item.property}OrderBy`] = item.order;
    });
    if (!order) {
      this.filterParam[`${property}OrderBy`] = '';
    }
    this.current = 1;
    this.fetchTableData();
  }
  trendData: any = {};
  trendVisible: boolean = false;
  //显示下发轨迹
  showTrend(record: any) {
    this.trendData = record;
    this.trendData.businessKey = record.id;
    this.trendData.businessType = '01';
    this.trendVisible = true;
  }
  //关闭弹框
  closeIt() {
    this.trendVisible = false;
  }
  //重新下发
  redistribute() {
    this.closeIt();
    this.fetchTableData();
  }
}
